import { useCallback, useMemo } from 'react';
import useBook from '../books/useBook';
import { getBookDataByID } from 'modules/assignments/helper';
import {
  extenionGetPageData,
  modifyAssignmentForStudent,
  sortByCustomType,
} from 'utils/lib/ebookHelper';

const useGetEngageAssignment = ({ bookId, pageId }) => {
  const bookState = useBook();

  const sortassignableActivity = useCallback((pageData) => {
    try {
      const modAssignableActivity = pageData.assignableActivity;
      const data = sortByCustomType(modAssignableActivity);
      const xyz = data?.filter((x) => x?.type?.toLowerCase() !== 'custom');

      const sortedActivities = [...xyz].sort((a, b) => {
        const seqA = parseInt(a.sequence_order) || 0;
        const seqB = parseInt(b.sequence_order) || 0;
        return seqA - seqB;
      });

      const finalResult = [
        ...sortedActivities,
        ...data?.filter((x) => x?.type?.toLowerCase() === 'custom'),
      ];
      return finalResult;
    } catch (error) {
      console.log(error);
    }
  }, []);

  const bookData = useMemo(() => {
    const bookData = getBookDataByID(bookState, bookId);
    return bookData;
  }, [bookId, bookState]);

  const pageData = useMemo(() => {
    try {
      const pageData = extenionGetPageData(
        bookData,
        pageId,
        bookState?.quiz,
        bookState?.activity,
        null,
        bookId,
        {
          [bookId]: [pageId],
        },
        'extensionActivity',
      );
      return pageData;
    } catch (error) {
      console.log(error);
    }
  }, [bookData, pageId, bookId]);

  const assignableEnageActivity = useMemo(() => {
    return sortassignableActivity(pageData);
  }, [pageData]);

  const assignedEngageActivity = useMemo(() => {
    const availableActivity = modifyAssignmentForStudent(
      pageData.availableActivity,
      bookState.isStudent,
      false,
      bookState.currentUser,
      bookState.servertime,
      bookState.timezone,
      bookState.currentClass,
      bookState.getHiddenBooks,
    );
    return availableActivity;
  }, [pageData, bookState]);

  return {
    assignableEnageActivity,
    assignedEngageActivity,
  };
};

export default useGetEngageAssignment;
